import React, { FC, ReactNode } from 'react';

import { Select } from '@.ui';
import { AdminFields } from '@/Components/Partials/Product/CreateProductForm/components/AdminField';
import { FormItemHeader } from '@/Components/Partials/Product/CreateProductForm/components/FormItemHeader';
import { FormItemWrapper } from '@/Components/Partials/Product/CreateProductForm/components/FormItemWrapper';

import S from './styles.module.scss';

interface dictionariesItem {
    id: number;
    name: string;
}

interface SelectFieldProps {
    headerText: string;
    isAllowed: boolean;
    dictionariesValues: dictionariesItem[];
    multiple?: boolean;
    required?: boolean;
    placeholder?: string;
    children?: ReactNode;
    localSearch?: boolean;
}

export const SelectField: FC<SelectFieldProps> = ({
    dictionariesValues,
    headerText,
    isAllowed,
    required,
    multiple,
    placeholder,
    children,
    localSearch,
    ...rest
}) => {
    /**
     * This stupidity due to the solution of typing the select
     */
    const createSelectComponent = (children: ReactNode, multiple = false) => {
        if (multiple) {
            if (localSearch) {
                return (
                    <Select {...rest} placeholder={placeholder} absolute multiple localSearch>
                        {children}
                    </Select>
                );
            }

            return (
                <Select {...rest} placeholder={placeholder} absolute multiple>
                    {children}
                </Select>
            );
        } else {
            if (localSearch) {
                return (
                    <Select {...rest} placeholder={placeholder} absolute localSearch>
                        {children}
                    </Select>
                );
            }

            return (
                <Select {...rest} placeholder={placeholder} absolute>
                    {children}
                </Select>
            );
        }
    };

    return (
        <FormItemWrapper>
            <FormItemHeader required={required}>{headerText}</FormItemHeader>
            <div className={S.selectWrapper}>
                <AdminFields isAllowed={isAllowed}>
                    {multiple
                        ? createSelectComponent(
                              dictionariesValues.map((item) => (
                                  <Select.Option key={item.id} id={item.id}>
                                      {item.name}
                                  </Select.Option>
                              )),
                              true
                          )
                        : createSelectComponent(
                              dictionariesValues.map((item) => (
                                  <Select.Option key={item.id} id={item.id}>
                                      {item.name}
                                  </Select.Option>
                              ))
                          )}
                </AdminFields>
            </div>
            {children}
        </FormItemWrapper>
    );
};
